import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "action", "onClick"];
import { useUsageTracking } from 'crm-object-board-core/usageTracking';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const CardQuickActionButton = _ref => {
  let {
      children,
      action,
      onClick
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    trackQuickActionClicked
  } = useUsageTracking();
  const handleClick = useCallback(e => {
    e.stopPropagation();
    if (action) {
      trackQuickActionClicked(action);
    }
    onClick === null || onClick === void 0 || onClick(e);
  }, [action, onClick, trackQuickActionClicked]);
  return /*#__PURE__*/_jsx(IconButton, Object.assign({}, rest, {
    tooltipProps: {
      maxInlineSize: '165px',
      onClick: e => {
        e.stopPropagation();
      }
    },
    size: "small",
    "data-test-id": "board-card-quick-action-button",
    "data-quick-action": action,
    use: "transparent",
    onClick: handleClick,
    children: children
  }));
};